import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ClientContactViewModel, ClienteViewModel} from '../../../../utils/ViewModels';

@Component({
  selector: 'app-agris-cotiz-detalle-guardar-dialog',
  templateUrl: './agris-cotiz-detalle-guardar-dialog.component.html',
  styleUrls: ['./agris-cotiz-detalle-guardar-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisCotizDetalleGuardarDialogComponent implements OnInit {

  @ViewChild('textarea') textarea: ElementRef;
  rows = 1;

  pdf = false;
  mail = false;
  observacion = false;
  observacionStr = '';

  forceSend = false;

  mailAdresses: ClientContactViewModel[] = [];
  selectedMail: ClientContactViewModel = null;
  cliente: ClienteViewModel = null;

  constructor() { }

  ngOnInit() {
  }

  autogrow() {
    this.rows = Math.ceil((this.textarea.nativeElement.scrollHeight - 10) / 18);
  }

  disableSubmit() {
    // si forzamos el envio, debemos habilitar el mail y debe haber alguna casilla de mail para seleccionar o bien debemos descargar el PDF
    return this.forceSend ? !((this.mail && this.mailAdresses.length) || this.pdf)
      : this.mail && !this.mailAdresses.length;
  }

}

export interface GuardarCotizOptions {
  pdf: boolean;
  mail: boolean;
  observacion: string;
  contacto: ClientContactViewModel;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-guardar-dialog/agris-cotiz-detalle-guardar-dialog.component.ts